

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { ExtensionAttributeFormComponent } from './extensionattribute-form/extensionattribute-form.component';
import { ExtensionAttributeComponent } from './extensionattribute.component';
import { ExtensionAttributeRoutes } from './extensionattribute.routing';

export function declaration() {
    return [ExtensionAttributeComponent, ExtensionAttributeFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class ExtensionAttributeModule {
}

@NgModule({
    imports: [ExtensionAttributeModule, ExtensionAttributeRoutes],
    exports: [ExtensionAttributeModule]
})
export class ExtensionAttributeWithRouteModule {
}
